export default "__VITE_ASSET__DKMkf$jO__"